import http from "../core/http";
const group = 'e';

export const getQuizzesRequest =  async (data) => {
	return await http.post(`${group}/getQuizzes`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getQuestionRequest =  async (data) => {
	return await http.post(`${group}/getQuestion`, data).then(res => res.data).catch(http.defaultCatch);
}

export const sendAnswerRequest =  async (data) => {
	return await http.post(`${group}/answer`, data).then(res => res.data).catch(http.defaultCatch);
}
